<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Telemedicina</h3>
        <p>Detalhes e benefícios do seu plano.</p>
      </div>
    </div>

    <template v-if="account && account.user && account.user.plan && account.user.plan.current && account.user.plan.current.service">
      <div class="row justify-content-center">
        <div class="col-lg-6">
          <router-link class="text-dark" tag="a" :to="'/telemedicina/plantao'">
            <div class="card card-icon" :class="account.user.plan.current.service.telemedicina">
              <div class="card-body bg-card" :style="{ backgroundImage: `url(${require('@/assets/images/bg/plantao-medico-24h.png')})` }">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                    <path
                      d="m5.705 3.71-1.41-1.42C1 5.563 1 7.935 1 11h1l1-.063C3 8.009 3 6.396 5.705 3.71zm13.999-1.42-1.408 1.42C21 6.396 21 8.009 21 11l2-.063c0-3.002 0-5.374-3.296-8.647zM12 22a2.98 2.98 0 0 0 2.818-2H9.182A2.98 2.98 0 0 0 12 22zm7-7.414V10c0-3.217-2.185-5.927-5.145-6.742C13.562 2.52 12.846 2 12 2s-1.562.52-1.855 1.258C7.184 4.073 5 6.783 5 10v4.586l-1.707 1.707A.996.996 0 0 0 3 17v1a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a.996.996 0 0 0-.293-.707L19 14.586z">
                    </path>
                  </svg>
                </div>
                <h5 class="mt-3">Plantão Médico 24h</h5>
                <p class="m-0">Consulta rápida e eficiente com clínico geral</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <h5 class="mt-3 mb-4 text-center">Outras opções</h5>

      <div class="row justify-content-center">
        <div class="col-lg-6">
          <router-link class="text-dark" tag="a" :to="'/telemedicina/consultas'">
            <div class="card card-icon" :class="account.user.plan.current.service.telemedicina">
              <div class="card-body d-flex align-items-center">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                    <path d="M4 6h2v2H4zm0 5h2v2H4zm0 5h2v2H4zm16-8V6H8.023v2H18.8zM8 11h12v2H8zm0 5h12v2H8z"></path>
                  </svg>
                </div>
                <div class="ml-3">
                  <h5 class="mb-1">Consultas</h5>
                  <p class="m-0">Histórico das suas consultas</p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-lg-6 d-none">
          <router-link class="text-dark" tag="a" :to="'/telemedicina/prontuario'">
            <div class="card card-icon" :class="account.user.plan.current.service.telemedicina">
              <div class="card-body d-flex align-items-center">
                <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(255, 255, 255, 1);">
                    <path
                      d="M8.434 20.566c1.335 0 2.591-.52 3.535-1.464l7.134-7.133a5.008 5.008 0 0 0-.001-7.072 4.969 4.969 0 0 0-3.536-1.463c-1.335 0-2.59.52-3.534 1.464l-7.134 7.133a5.01 5.01 0 0 0-.001 7.072 4.971 4.971 0 0 0 3.537 1.463zm5.011-14.254a2.979 2.979 0 0 1 2.12-.878c.802 0 1.556.312 2.122.878a3.004 3.004 0 0 1 .001 4.243l-2.893 2.892-4.242-4.244 2.892-2.891z">
                    </path>
                  </svg>
                </div>
                <div class="ml-3">
                  <h5 class="mb-1">Prontuário</h5>
                  <p class="m-0">Histórico das suas prescrições</p>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </template>
  </Layout>
</template>